import {useEffect} from 'react';
import {Button, css, view} from '@sail/ui/deprecated';
import {LightCard} from '@stripe-internal/conversations-ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {safeWindowOpen} from '@stripe-internal/safe-links';
import {FormattedMessage, defineMessages} from 'react-intl';

const messages = defineMessages({
  signInTitle: {
    id: 'mse_inline_data.universal_help_sign_in.sign_in_title',
    description: 'Label for the sign-in title.',
    defaultMessage: 'Sign in to your Stripe account',
  },
  signIn: {
    id: 'mse_inline_data.universal_help_sign_in.sign_in',
    description: 'Label for the sign-in button.',
    defaultMessage: 'Sign in',
  },
  cantSignIn: {
    id: 'mse_inline_data.universal_help_sign_in.cant_sign_in',
    description: "Label for the i-can't-sign-in button.",
    defaultMessage: "I can't sign in",
  },
  description: {
    id: 'mse_inline_data.universal_help_sign_in.description',
    description: 'Text for the sign-in card.',
    defaultMessage:
      'Clicking below will open a new browser window. This chat will stay right here, so you can pick up where you left off when you return.',
  },
});

export const SignInCard = ({
  url,
  setCantSignInSelected,
}: {
  url: string;
  setCantSignInSelected: (cantSignInSelected: boolean) => void;
}) => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.action('login_prompt_shown');
  }, [analytics]);

  return (
    <view.div
      css={{
        marginLeft: 'xlarge',
        marginRight: 'large',
      }}
    >
      <view.div
        css={{
          marginLeft: 'xsmall',
          marginTop: 'xsmall',
        }}
      >
        <LightCard isOuter>
          <view.div css={{stack: 'y', gap: 'medium'}}>
            <view.div
              css={{margin: 0, fontWeight: 'bold', fontSize: css.value('14px')}}
              data-testid="uh-sign-in-prompt-title"
            >
              <FormattedMessage {...messages.signInTitle} />
            </view.div>
            <view.div
              data-testid="uh-sign-in-prompt-description"
              css={{fontSize: css.value('12px')}}
            >
              <FormattedMessage {...messages.description} />
            </view.div>
            <view.div css={{stack: 'y', gap: 'small'}}>
              <Button
                data-testid="uh-sign-in-prompt-sign-in-button"
                type="primary"
                css={{width: 'fill'}}
                onPress={() => {
                  analytics.action('clicked_login');
                  safeWindowOpen(url);
                }}
              >
                <FormattedMessage {...messages.signIn} />
              </Button>

              <Button
                data-testid="uh-sign-in-prompt-cant-sign-in-button"
                type="secondary"
                css={{width: 'fill'}}
                onPress={() => {
                  analytics.action('clicked_cant_login');
                  setCantSignInSelected(true);
                }}
              >
                <FormattedMessage {...messages.cantSignIn} />
              </Button>
            </view.div>
          </view.div>
        </LightCard>
      </view.div>
    </view.div>
  );
};
